import React from "react";
import { SVGProps } from "react";

function DebitCardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5 3.40351V3C13.5 2.44772 13.0523 2 12.5 2H1.5C0.947715 2 0.5 2.44772 0.5 3V11C0.5 11.5523 0.947715 12 1.5 12H12.5C13.0523 12 13.5 11.5523 13.5 11V6.1579C13.5 5.60561 13.0523 5.15789 12.5 5.15789H2.4589"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default DebitCardIcon;
